/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
export var SourceTypes;
(function (SourceTypes) {
    SourceTypes[SourceTypes["Unspecified"] = 0] = "Unspecified";
    SourceTypes[SourceTypes["DataverseTable"] = 534120000] = "DataverseTable";
    SourceTypes[SourceTypes["CjoInteractionEvent"] = 534120001] = "CjoInteractionEvent";
    SourceTypes[SourceTypes["CjoBusinessEvent"] = 534120002] = "CjoBusinessEvent";
    SourceTypes[SourceTypes["CjoCustomEvent"] = 534120003] = "CjoCustomEvent";
    SourceTypes[SourceTypes["Legal"] = 534120004] = "Legal";
    SourceTypes[SourceTypes["External"] = 534120005] = "External";
})(SourceTypes || (SourceTypes = {}));
export var SourceSystem;
(function (SourceSystem) {
    SourceSystem[SourceSystem["RTM"] = 0] = "RTM";
    SourceSystem[SourceSystem["OBM"] = 1] = "OBM";
})(SourceSystem || (SourceSystem = {}));
